import { SERVER_URL } from "../consts";
import logger from "./Logger";

export const getSchoolRatingForLocations = async (locations) => {
  const data = [locations];
  logger.info("School rating, This is the data sent to the backend - ", data);
  let dataResponse;
  const queryString = data.map((obj) => `data=${encodeURIComponent(JSON.stringify(obj))}`).join("&");

  await fetch(`${SERVER_URL}/api/v1/schools/getSchoolRating?${queryString}`, {
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    method: "POST",
  })
    .then(async (response) => {
      const jsonResponse = await response.json();
      logger.info("Response from getting school ratings - ", jsonResponse);
      dataResponse = jsonResponse;
    })
    .catch((error) => console.error(error));
  return dataResponse;
};
